import { Info, Spinner } from '@mi-front/ui';
import { FormattedMessage } from 'react-intl';
import { useFragmentQuery } from '../../../../../hooks/useFragment';
import { useFragmentCtx } from '../../../context/fragment-ctx';
import { MediaStatusInfo } from './MediaStatusInfo';

export const MediaStatus = () => {
  const query = useFragmentQuery(useFragmentCtx().id);

  return (
    <Info
      title={
        <FormattedMessage id="fragments.mediaStatus.title" defaultMessage="Archivos de media" />
      }
      data={query.isLoading ? <Spinner /> : query.data && <MediaStatusInfo fragment={query.data} />}
    />
  );
};
